import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../../context/AppContext';
import styles from './SearchBarPhoneInput.module.scss';
import InputMask from 'react-input-mask';


const SearchBarPhoneInput = (props: any) => {
    const { name, updateName, updateSelectedSpecialty, updateLocation } = useContext(AppContext);
    
    useEffect(() => {
        updateSelectedSpecialty('');
        updateLocation('')
    }, [])

  return (
    <div className={styles.locationInputContainer}>
      <InputMask
        className={styles.locationInput}
        mask='(+1) (999) 999 - 9999'
        type="text"
        placeholder="Phone number"
        value={name === 'undefined' ? '' : name}
        onChange={(e) => { 
          const inputValue = e.target.value;
          const numericValue = inputValue.replace(/\D/g, ''); // Remove non-numeric characters
          updateName( numericValue);
        }}
      />
    </div>
  );
};

export default SearchBarPhoneInput;
